import { cx } from "../utils/cx";
import styles from "./Spinner.module.css";

interface SpinnerProps {
  /** "sm" (14px), "md" (20px, default), or "lg" (32px). */
  size?: "sm" | "md" | "lg";
  /** Accessible label announced to screen readers. */
  label?: string;
}

/**
 * The single KCC loading indicator (style-guide.md: Loading Spinner) — a
 * rotating ring with an accent arc. Respects reduced motion via the global
 * override in kcc-theme.css.
 */
function Spinner({ size = "md", label = "Loading" }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cx(styles.spinner, size === "sm" && styles.sm, size === "lg" && styles.lg)}
    />
  );
}

export default Spinner;
